import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserUpdateFormFactory } from './user-update-form.factory';
import { UserUpdateOptions } from '../../../../../../../../common/src/options/user-update.options';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { Locale } from '@magieno/common';
import { environment } from '../../../../environments/environment';
import {
  UserUpdateOptions as ApiUserUpdateOptions,
} from '../../../../../../../../common/dist/angular/options/user-update.options';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { LocaleService } from '../../../../../../modules/src/lib/advanced-auth/services/locale.service';
import { UserApiController } from '../../../../../../modules/src/lib/advanced-auth/api-controllers/user.api-controller';
import { AuthService, User } from '@auth0/auth0-angular';


@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
  standalone: false,
})
export class GeneralComponent implements OnInit {

  public isSocialLogin = false;

  public readonly form: AdvancedForm<UserUpdateOptions> = this.userUpdateFormFactory.create();

  user?: User;

  constructor(public readonly userUpdateFormFactory: UserUpdateFormFactory,
              private translate: TranslateService,
              private readonly localeService: LocaleService,
              private readonly auth: AuthService,
              private readonly userApiController: UserApiController) {
  }

  get firstName(): AdvancedFormControl<string, string, string> {
    return this.form.formElements.firstName as AdvancedFormControl<string, string, string>;
  }

  get lastName(): AdvancedFormControl<string, string, string> {
    return this.form.formElements.lastName as AdvancedFormControl<string, string, string>;
  }

  get language(): AdvancedFormControl<Locale, Locale, Locale> {
    return this.form.formElements.language as AdvancedFormControl<Locale, Locale, Locale>;
  }

  ngOnInit(): void {
    this.language.setNormalizedValue(this.translate.currentLang as Locale);

    this.auth.user$.subscribe(value => {
      this.user = value;
    });

    this.form.buttonClick$.subscribe(() => {
      this.form.lifecycleStatus = FormLifecycleStatusEnum.Loading;

      const promises = [];

      if (this.isSocialLogin === false) {
        const userUpdateOptions = new ApiUserUpdateOptions();
        userUpdateOptions.lastName = this.lastName.value;
        userUpdateOptions.firstName = this.firstName.value;
        promises.push(this.userApiController.updateUser(userUpdateOptions));
      }

      // todo for now we only support fr
      // promises.push(this.localeService.setLocaleForUser(this.language.value));

      Promise.allSettled(promises).then((values) => {
        for (let i = 0; i < values.length; i++) {
          const value = values[i];
          if (i === 0) {
            if (value.status === 'fulfilled') {
              const userIdentity = value.value;
              this.firstName.setNormalizedValue(userIdentity.firstName);
              this.lastName.setNormalizedValue(userIdentity.lastName);
              this.setIsSocialLogin(userIdentity.isSocial ?? false);
            } else {
              console.error('Error updating user');
            }
          }

          // todo for now we only support fr
          // else if (i === 1) {
          //     if (value.status === "fulfilled") {
          //         const userIdentity = value.value;
          //         console.log("Using locale", userIdentity.appMetadata.locale);
          //         this.translate.use(userIdentity.appMetadata.locale);
          //     } else {
          //         console.error("Error saving new locale");
          //         this.translate.use(this.language.value);
          //     }
          // }
        }

        this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
        if (this.isSocialLogin === true) {
          this.firstName.lifecycleStatus = FormLifecycleStatusEnum.Loading;
          this.lastName.lifecycleStatus = FormLifecycleStatusEnum.Loading;
        }
      });
    });

    this.auth.idTokenClaims$.subscribe((token) => {
      this.setIsSocialLogin(token[environment.auth0Audience + '/isSocial'] ?? false);
    });
  }

  setIsSocialLogin(isSocial: boolean) {
    this.isSocialLogin = isSocial;
    this.firstName.lifecycleStatus = isSocial ? FormLifecycleStatusEnum.Loading : FormLifecycleStatusEnum.ReadyForInput;
    this.lastName.lifecycleStatus = isSocial ? FormLifecycleStatusEnum.Loading : FormLifecycleStatusEnum.ReadyForInput;
  }
}
